import 'splitting/dist/splitting.css'
import 'splitting/dist/splitting-cells.css'
import './src/scss/index.scss'

import Wrapper from './wrapper'
export const wrapRootElement = Wrapper
